import { render } from "./BanksPage.vue?vue&type=template&id=5c77cd7b&ts=true"
import script from "./BanksPage.vue?vue&type=script&lang=ts"
export * from "./BanksPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__